import React, { useState } from "react";
import axios from 'axios';
import Header from './header'; // Ensure the import path is correct
import { useNavigate } from "react-router-dom";
import "../styles/waitlist.css";

export default function PeopleWaitlist() {
    const navigate = useNavigate();

    const [email, setEmail] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault(); // Prevent the default form submission behavior
        try {
            const res = await axios.post('https://api.plytol.co.uk/api/web_register',
                { 'email': email, 'type': "People", },
                {
                    headers: {
                        "Content-Type": "application/json; charset=UTF-8",
                        'x-api-key': process.env.REACT_APP_API_KEY, // Use the API key from the environment variable
                    }
                }
            );

            if (res.status === 200) {
                // go to "thanks for signing up" page
                navigate("/success");
            } else if (res.status === 201) {
                // go to "you have already signed up" page
                navigate("/failed");
            } else {
                throw Error(res.status);
            }
        } catch (error) {
            navigate("/error");
            console.error('There was an error adding the user!', error);
        }
    };

    return (
        <div className="contact--container">
            <Header />
            <img src="airdeska_drop.svg" className="contact--img" alt="AirDeska teardrop" />
            <div className="form--container">
                <h1>Join the Waitlist for</h1>
                <h1>AirDeska People Today!</h1>
                <br />
                <p>Join the Waitlist for the new AirDeska app, coming exclusively to iOS and Android soon.</p>
                <p>Sign up today to receive emails and updates on the road to launch!</p>
                <form className="contact--form" onSubmit={handleSubmit}>
                    <div className="form--input">
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Email Address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form--button">
                        <button type="submit">Join Waitlist</button>
                    </div>
                </form>
            </div>
        </div>
    );
}
